import sqroll from "https://esm.sh/sqroll@1.1.3";

const sq = sqroll();

//elements are the page elements referenced by menu
//to be precise, items which are used to build the menu,
//because they have a 'data-nav' attribute.
const elements = document.querySelectorAll('[data-nav]');

//navsel is the menu anchors mapped to expose the href for easier traversal
const navsel = [...document.querySelectorAll('nav.top-bar-nav a')].map(function(item){
  return {
    item: item,
    selectorId: item.attributes['href'].value
  }
});

const navmenu = document.querySelector('nav.top-bar-nav');

//todo: make a web component that handles this.
function setSelected(selectorId){
  navsel.forEach(function(item) {
    if (item.selectorId === selectorId) {
      item.item.classList.add('selected');
    } else {
      item.item.classList.remove('selected');
    }
  });
}

function unSelectAll() {
  navsel.forEach(function(item) {
      item.item.classList.remove('selected');
  });
}

function toggleUpButton() {
  navmenu.classList.toggle('show-to-top-button');
};



//it seems like there's a bit of a delay, so multiple occurences ...
for (element of elements) {
  sq.viewport(element, {
    offset: '50vh 10vh',
    onIn: (el, currentScroll, direction) => {
      let id = "#" + el.id;
      setSelected(id);
    },
    onOut: (el, currentScroll, direction) => {
      return
    }
  });
}

//bug: functionality is reversed if page is loaded at anchor lower down page.
sq.viewport(document.querySelector('.banner'), {
  offset: '0px 60vh',
  onIn: (el, currentScroll, direction) => {
      if (direction === 'up') {
        unSelectAll();
        toggleUpButton();
      }
    },
  onOut: (el, currentScroll, direction) => {
    toggleUpButton();
  }
});

sq.start();
    
